module.exports = __webpack_public_path__ + "img/967aaab.jpg";